import MailchimpFormContainer from './MailChimp';


export default function Footer() {
    return (
        <footer className="w-full h-64 bg-black static bottom-0 pt-10">
            <MailchimpFormContainer />

            <p className="px-6 text-gray-500 font-serif text-left bg-black">© Ocean Beach Brands</p>
        </footer>
    );
}
